import { Flex } from "antd";
import styles from "./index.module.less";
import p2Img1 from "./imgs/p2_img1.png";
import p2Img2 from "./imgs/p2_img2.png";
import p2Img3 from "./imgs/p2_img3.png";
import p3Icon1 from "./imgs/p3_icon1.svg";
import p3Icon2 from "./imgs/p3_icon2.svg";
import p3Icon3 from "./imgs/p3_icon3.svg";
import p3Icon4 from "./imgs/p3_icon4.svg";
import p3Icon5 from "./imgs/p3_icon5.svg";
import psBgImg from "./imgs/p3_bg.png";
import P1Content from "@/components/P1Content";
import data from "./data";
import { isMobile } from "@/utils";
import MobileYiqiliao from "./mobile";

const iconMap = {
  p3Icon1,
  p3Icon2,
  p3Icon3,
  p3Icon4,
  p3Icon5,
};

const P3Card = ({
  title,
  desc,
  icon,
}: {
  title?: string;
  desc?: string;
  icon?: string;
}) => {
  return (
    <div className={styles.p3_card}>
      <div className={styles.p3_card_title}>{title}</div>
      <div className={styles.p3_card_desc}>{desc}</div>
      <div className={styles.p3_card_icon}>
        <img src={icon && iconMap[icon as keyof typeof iconMap]} />
      </div>
    </div>
  );
};
const P3CardRight = ({
  title,
  desc,
  icon,
}: {
  title?: string;
  desc?: string;
  icon?: string;
}) => {
  return (
    <div className={styles.p3_card1}>
      <div className={styles.p3_card_title}>{title}</div>
      <div className={styles.p3_card_desc}>{desc}</div>
      <div className={styles.p3_card_icon}>
        <img src={icon && iconMap[icon as keyof typeof iconMap]} />
      </div>
    </div>
  );
};
const Yiqiliao = () => {
  return (
    <div className={styles.agentx}>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          link={data.p1.link}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <Flex gap={".96rem"}>
            <Flex vertical className={styles.p2_texts}>
              <div className={styles.p2_title}>
                {data.p2.title1}<br/>
                {data.p2.title2.split(data.p2.subtitle)[0]}
                <span>{data.p2.subtitle}</span>
              </div>
              {data.p2.desc.map((desc, i) => (
                <div className={styles.p2_desc} key={i}>
                  {desc}
                </div>
              ))}
            </Flex>
            <Flex gap={".2rem"} className={styles.p2_imgs}>
              <img src={p2Img1} />
              <Flex vertical gap={".2rem"}>
                <img src={p2Img2} />
                <img src={p2Img3} />
              </Flex>
            </Flex>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>{data.p3.title}</div>
          <img src={psBgImg} className={styles.p3_bg} />
          <Flex justify="space-between" className={styles.p3_list}>
            <Flex vertical gap={".2rem"}>
              {data.p3.list1.map((item, index) => (
                <P3Card key={index} {...item} icon={item.icon} />
              ))}
            </Flex>
            <Flex vertical gap={".2rem"}>
              {data.p3.list2.map((item, index) => (
                <P3CardRight key={index} {...item} icon={item.icon} />
              ))}
            </Flex>
          </Flex>
        </div>
      </div>
    </div>
  );
};
export default isMobile() ? MobileYiqiliao : Yiqiliao;
